/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Tag_ExperienceInputs */

const en_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronological Ledger`)
};

const ar_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السجل الزمني`)
};

const bn_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের অভিজ্ঞতা`)
};

const de_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronologisches Hauptbuch`)
};

const es_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libro mayor cronológico`)
};

const fr_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grand livre chronologique`)
};

const pt_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razão Cronológica`)
};

const zh_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间顺序分类帐`)
};

const tr_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kronolojik Defter`)
};

const ru_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хронологический регистр`)
};

const pl_resume_tag_experience = /** @type {(inputs: Resume_Tag_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Księga chronologiczna`)
};

/**
* | output |
* | --- |
* | "Chronological Ledger" |
*
* @param {Resume_Tag_ExperienceInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_tag_experience = /** @type {((inputs?: Resume_Tag_ExperienceInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Tag_ExperienceInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_tag_experience(inputs)
	if (locale === "bn") return bn_resume_tag_experience(inputs)
	if (locale === "de") return de_resume_tag_experience(inputs)
	if (locale === "es") return es_resume_tag_experience(inputs)
	if (locale === "fr") return fr_resume_tag_experience(inputs)
	if (locale === "pt") return pt_resume_tag_experience(inputs)
	if (locale === "zh") return zh_resume_tag_experience(inputs)
	if (locale === "tr") return tr_resume_tag_experience(inputs)
	if (locale === "ru") return ru_resume_tag_experience(inputs)
	if (locale === "pl") return pl_resume_tag_experience(inputs)
	return en_resume_tag_experience(inputs)
});